<template>
    <rkm-layout-body title="Lista de ferida">
        <template v-slot:actions>
            <rkm-button
                @click="$router.push({name: 'cadastro-ferida-create'})"
                authorize="store-cadastro-ferida"
                color="primary"
            >
                Cadastrar ferida
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
// Components.
import List from '@/components/cadastro/ferida/List'

export default {
    components: {List},
}
</script>